module.exports = __webpack_public_path__ + "static/media/slide-image-1-small-min.fe94aa54.jpg";